<div (dblclick)="setEditMode()"
     class="row m-b-xs">
  <div class="col-md-3">
    <label>Sharing</label>
  </div>
  <div class="col-md-9" *ngIf="!isEditMode">
    <span>{{shareType ? shareTypeNames[shareType] : 'Staff only'}}</span>

    <i class="fa fa-pencil pull-right"
       *ngIf="isCanEdit"
       (click)="setEditMode()"
       data-toggle="tooltip"
       data-placement="top"
       title="Edit"></i>
  </div>

  <div class="dv-value-edit col-md-9" *ngIf="isEditMode">
    <select class="form-control" name="isPublic" [(ngModel)]="shareType">
      <option [ngValue]="null">Staff only</option>
      <option *ngFor="let option of currentShareTypeOptions" [ngValue]="option.value">{{option.name}}</option>
    </select>

    <button type="button"
            style="border: 1px solid #dedfe0"
            (click)="updateSharingOptions()">
      <i class="fa fa-check"></i>
    </button>

    <button type="button" (click)="setEditMode(false)">
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>

<div *ngIf="shareType === shareTypes.Residents || selectedItem?.documentsPermissions?.length" class="row m-b-xs" (dblclick)="setEditMode()">
  <div class="col-md-3">
    <label>Occupancy Type</label>
  </div>
  <div class="col-md-9" *ngIf="!isEditMode">
    <permissions [showPeriod]="false"
                 [parentElementSelector]="'.col-md-9'"
                 [permissions]="selectedItem.documentsPermissions">
    </permissions>

    <i class="fa fa-pencil pull-right"
       *ngIf="isCanEdit"
       (click)="setEditMode()"
       data-toggle="tooltip"
       data-placement="top"
       title="Edit"></i>
  </div>
  <div class="col-md-9" *ngIf="isEditMode">
    <permissions-select [permissionsList]="permissionsList"
                        [permissions]="selectedItem.documentsPermissions"
                        (onChange)="onDocumentPermissionsChange($event)">
    </permissions-select>
  </div>
</div>

<div *ngIf="shareType === shareTypes.Groups || selectedItem?.userGroups?.length" class="row m-b-xs clickable"
     (dblclick)="setEditMode()">
  <div class="col-md-3">
    <label>User Groups</label>
  </div>
  <div class="col-md-9 display-flex" *ngIf="!isEditMode">
    <span *ngIf="selectedItem.userGroups.length < 1">-</span>
    <div class="m-r-md" style="width: 220px;">
      <multiselect-field *ngIf="selectedItem.userGroups.length > 0"
                         name="userGroups"
                         [data]="currentUserGroups || []"
                         [noEdit]="true"
                         [(ngModel)]="selectedItem.userGroups">
      </multiselect-field>
    </div>
    <div (click)="setEditMode()" *ngIf="isCanEdit">
      <i class="fa fa-pencil pull-right m-t-xs" data-toggle="tooltip" data-placement="top" title="Edit"></i>
    </div>
  </div>
  <div *ngIf="isEditMode" class="col-md-9">
    <angular2-multiselect name="userGroups"
                          [data]="currentUserGroups"
                          [(ngModel)]="selectedItem.userGroups"
                          [settings]="multiselectSettings">
    </angular2-multiselect>
  </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-detailed-view/sharing-form-fields/sharing-form-fields.component.html